import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="main"
export default class extends Controller {
  static targets = ["exclude", "followers", "filter", "status"]

  connect() {
    this.toggleFields();
    this.active();
  }

  toggle() {
    this.toggleFields();
  }

  toggleFields() {
    // console.log(this.element);
    if (this.hasFilterTarget) {
      const disabled = !this.filterTarget.checked; // Correctly reference the checkbox
      this.excludeTarget.disabled = disabled
      this.followersTarget.disabled = disabled
    }
  }
  active() {
    if (this.hasStatusTarget) {
      if (!this.statusTarget.checked) {
        this.element.classList.add("inactive-kwd")
      }
      else {
        this.element.classList.remove("inactive-kwd")
      }
    }
  }
  changeActive(event) {
    this.element.requestSubmit(); // Submits the form via Turbo
  }
  delete(event) {
    event.preventDefault()

    if (confirm("Are you sure?")) {
      const form = event.target.closest('form')
      form.requestSubmit()
    }
  }
  download() {
    setTimeout(() => {
      Turbo.visit(window.location.href, { action: "replace" });
    }, 2000);
  }
}
